import { Base } from "../core/base.model";

export class VersionBean extends Base {
/** El id numérico de cos_version o, en un proyecto de Mongo, el UUID de la versión. */
id: number | string;
nombre: string;
detalle: String;
archivo: String;
ruta: String;
fecha_creacion: String;
idCliente: String;
cliente: String;
id_proyecto: number;
idetapa: number;
id_version_qa: number;

isAddVersion:boolean;






}